export const MonitoringConstants = {
    GET_SESSION_LOGS_REQUEST: 'GET_SESSION_LOGS_REQUEST',
    GET_SESSION_LOGS_SUCCESS: 'GET_SESSION_LOGS_SUCCESS',
    GET_SESSION_LOGS_ERROR: 'GET_SESSION_LOGS_ERROR',
}